import axios from 'axios'
import type { BaseQueryArgs, QueryArgs } from './types'
import { tokenInterceptor } from './interceptors/tokenInterceptor'
import { languageInterceptor } from './interceptors/languageInterceptor'
import { onlyCountInterceptor } from './interceptors/onlyCountInterceptor'
import {
  recieveFingerprintInterceptor,
  sendFingerprintInterceptor,
} from './interceptors/fingerprintInterceptor'
import { traceIdInterceptor } from './interceptors/traceIdInterceptor'

export const axiosInstance = async (args: QueryArgs, baseQueryArgs: BaseQueryArgs) => {
  const a = axios.create()

  a.defaults.withCredentials = true
  a.defaults.timeout = 310 * 1000 // 310 seconds

  // request interceptors
  a.interceptors.request.use(tokenInterceptor(args))
  a.interceptors.request.use(languageInterceptor(args))
  a.interceptors.request.use(onlyCountInterceptor(args))
  a.interceptors.request.use(sendFingerprintInterceptor(args))
  a.interceptors.request.use(traceIdInterceptor(args))

  // response interceptors
  a.interceptors.response.use(recieveFingerprintInterceptor(args))

  const isFullUrl = args.url.startsWith('http://') || args.url.startsWith('https://')

  const axiosResponse = await a({
    url: isFullUrl ? args.url : (baseQueryArgs.baseUrl ?? '') + args.url,
    method: args.method,
    data: args.data,
    params: args.params,
    withCredentials: args.withCredentials,
    headers: {
      ...baseQueryArgs.defaultHeaders,
      ...args.headers,
    },
    responseType: args.isBlob ? 'blob' : undefined,
  })

  return axiosResponse
}
